module.exports = __webpack_public_path__ + "21a2781193121c69f8208acac9a42cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/cash.png
// module id = 318
// module chunks = 0